import * as ko from 'knockout';
import XDate from 'xdate';

import IBillAttachmentDetails from '@/features/accounting-software/types/IBillAttachmentDetails';
import IInvoiceCustomerDetails from '@/features/accounting-software/types/IInvoiceCustomerDetails';
import InvoiceData from '@/features/accounting-software/types/InvoiceData';

// @todo just a copy of bill for now
class Invoice {
  public amount: number;

  public memo: string;

  public invoiceNumber: string;

  public id: string;

  public currency: string;

  public date: Date;

  public pay: KnockoutObservable<boolean> = ko.observable(false);

  public customer: IInvoiceCustomerDetails;

  public inProgress: boolean;

  public attachments = ko.observableArray<IBillAttachmentDetails>([]);

  public hasAttachments: boolean;

  public isPadAgreementCompleted: boolean;

  public attachmentStatus = ko.observable<string>('loadRequired');

  constructor(data: InvoiceData) {
    // This pulls in customer prefill data like address details, print name on check as, etc...
    this.customer = data.customer;

    const utcDate = new XDate(data.date, true); // Date comes in this format: "2019-01-01T00:00:00Z" (Parse it in UTC format)
    this.date = new Date(utcDate.getFullYear(), utcDate.getMonth(), utcDate.getDate()); // re-create the date to base it users browser timezone

    this.amount = data.amount;
    this.invoiceNumber = data.invoiceNumber;
    this.id = data.id;
    this.currency = data.currency;
    this.inProgress = data.inProgress;
    this.hasAttachments = data.hasAttachments;
    this.isPadAgreementCompleted = data.isPadAgreementCompleted;

    if (data.memo) {
      this.memo = data.memo;
    }
  }
}

export default Invoice;
